/**
 * Build-time configs for local dev
 */

// Intentionally using process.env as this is a builtime config, for local dev
export const AUTH_TOKEN_OVERRIDE = process.env.REACT_APP_AUTH_TOKEN_OVERRIDE
